<template>
  <modal>
    <template slot="header">
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeNoPilotEmailsWarning"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>business</md-icon>
          </div>
          <h4 class="title" style="text-align: left">
            {{ $t("Some pilots don't have emails!") }}
          </h4>
        </md-card-header>

        <md-card-content class="">
          <h5>
            {{
              $t(
                "Please make sure all your pilots, observers, and payload operators have emails set before using the Projects feature."
              )
            }}
          </h5>
        </md-card-content>
      </md-card>
    </template>

    <template slot="footer">
      <md-button class="md-primary" @click="openUsersPage">
        {{ $t("Update Users") }}
      </md-button>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";
import { router } from "@/main";

export default {
  components: { Modal },
  methods: {
    closeNoPilotEmailsWarning() {
      this.$emit("closeNoPilotEmailsWarning");
    },
    openUsersPage() {
      router.push("/settings/pilot");
    }
  }
};
</script>
